// Move quantity and add to cart elements to purchase section on desktop/fullscreen
document.addEventListener('DOMContentLoaded', function() {
  function movePurchaseElements() {
    const isDesktop = window.innerWidth >= 990;
    
    // Get elements - try multiple selectors for quantity
    let quantitySelector = document.querySelector('[data-block-type="quantity_selector"]');
    if (!quantitySelector) {
      quantitySelector = document.querySelector('.product-form__quantity');
    }
    if (!quantitySelector) {
      quantitySelector = document.querySelector('[id*="Quantity-Form"]');
    }
    
    // For buy buttons, we need to find the product-form element
    let productForm = document.querySelector('product-form');
    let buyButtons = document.querySelector('[data-block-type="buy_buttons"]');
    
    // Try alternative selectors if the above don't work
    if (!productForm) {
      productForm = document.querySelector('.product-form');
    }
    
    const purchaseSection = document.querySelector('.product__purchase-section');
    const mainInfoSection = document.querySelector('.product__info-main');
    const shippingWidget = purchaseSection ? purchaseSection.querySelector('.shipping-delivery-widget') : null;
    
    
    if (!purchaseSection || !mainInfoSection) return;
    
    if (isDesktop) {
      // Move to purchase section on desktop
      // Create a container for quantity and buttons
      let purchaseContainer = purchaseSection.querySelector('.purchase-form-container');
      if (!purchaseContainer) {
        purchaseContainer = document.createElement('div');
        purchaseContainer.className = 'purchase-form-container';
        
        // Find the correct insertion point - after price, before sold-by
        const priceSection = purchaseSection.querySelector('.purchase-price');
        const soldBySection = purchaseSection.querySelector('.purchase-sold-by');
        
        if (priceSection && soldBySection) {
          // Insert after price, before sold-by
          priceSection.parentNode.insertBefore(purchaseContainer, soldBySection);
        } else if (shippingWidget) {
          // Fallback: Insert before shipping widget
          shippingWidget.parentNode.insertBefore(purchaseContainer, shippingWidget);
        } else {
          // Last resort: append to end
          purchaseSection.appendChild(purchaseContainer);
        }
      }
      
      // Move quantity selector first
      if (quantitySelector && !purchaseContainer.contains(quantitySelector)) {
        purchaseContainer.appendChild(quantitySelector);
        quantitySelector.classList.add('purchase-quantity');
      }
      
      // Move the entire product-form element (which contains buy buttons)
      // Don't clone - just move the actual element to preserve functionality
      if (productForm && !purchaseContainer.contains(productForm)) {
        purchaseContainer.appendChild(productForm);
        productForm.classList.add('purchase-actions');
        
        // Force visibility in case CSS is hiding it
        productForm.style.display = 'block';
        productForm.style.visibility = 'visible';
      } else if (buyButtons && !purchaseContainer.contains(buyButtons)) {
        // Fallback: just move buy buttons if product-form not found
        purchaseContainer.appendChild(buyButtons);
        buyButtons.classList.add('purchase-actions');
      }
    } else {
      // Move back to main info section on mobile
      // Find the right position to insert them back
      const priceBlock = mainInfoSection.querySelector('[data-block-type="price"]');
      const variantPicker = mainInfoSection.querySelector('[data-block-type="variant_picker"]');
      const insertAfter = variantPicker || priceBlock;
      
      if (quantitySelector && insertAfter && !mainInfoSection.contains(quantitySelector)) {
        // Insert quantity after variant picker or price
        insertAfter.parentNode.insertBefore(quantitySelector, insertAfter.nextSibling);
        quantitySelector.classList.remove('purchase-quantity');
      }
      
      // Move product-form or buy buttons back
      if (productForm && quantitySelector && !mainInfoSection.contains(productForm)) {
        // Insert product form after quantity
        quantitySelector.parentNode.insertBefore(productForm, quantitySelector.nextSibling);
        productForm.classList.remove('purchase-actions');
        // Reset inline styles
        productForm.style.display = '';
        productForm.style.visibility = '';
      } else if (buyButtons && quantitySelector && !mainInfoSection.contains(buyButtons)) {
        // Fallback: just move buy buttons
        quantitySelector.parentNode.insertBefore(buyButtons, quantitySelector.nextSibling);
        buyButtons.classList.remove('purchase-actions');
      }
    }
  }
  
  // Run on page load with a small delay to ensure elements are rendered
  setTimeout(movePurchaseElements, 100);
  
  // Also try immediately
  movePurchaseElements();
  
  // Run on resize with debounce
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(movePurchaseElements, 250);
  });
  
  // Also run when variant changes
  if (window.subscribe) {
    window.subscribe(PUB_SUB_EVENTS.variantChange, function() {
      setTimeout(movePurchaseElements, 100);
    });
  }
});